import React from 'react';
import { useRecoilValue } from 'recoil';
import { languageState } from '../../recoil/language/languageAtom';
import StarbeatNoticeKO from './StarbeatNoticeKO';
import StarbeatNoticeEN from './StarbeatNoticeEN';
import StarbeatNoticeJP from './StarbeatNoticeJP';

const StarbeatNotice = () => {
  const selectedLanguage = useRecoilValue(languageState);

  let starbeatNoticeChildrenComponent;

  if (selectedLanguage === 'en') {
    starbeatNoticeChildrenComponent = <StarbeatNoticeEN />;
  } else if (selectedLanguage === 'ko') {
    starbeatNoticeChildrenComponent = <StarbeatNoticeKO />;
  } else if (selectedLanguage === 'jp') {
    starbeatNoticeChildrenComponent = <StarbeatNoticeJP />;
  } else {
    // 디폴트 언어
    starbeatNoticeChildrenComponent = <StarbeatNoticeEN />;
  }

  return <div className='starbeat-notice-desc-wrapper'>{starbeatNoticeChildrenComponent}</div>;
};

export default StarbeatNotice;
